import React, { useState } from "react";

const AddressInputField = ({
  label,
  id,
  value,
  onChange,
  placeholder = "",
  className = "",
  labelClassName = "",
  maxlength = 1000, // Default max length
  disabled = false, // New disabled prop
  error = "",
}) => {
  const [remaining, setRemaining] = useState(maxlength - (value?.length || 0));

  const handleInputChange = (newValue) => {
    setRemaining(maxlength - newValue.length);
    onChange(newValue);
  };

  return (
    <div className="w-full flex flex-col gap-1">
      {label && (
        <label
          htmlFor={id}
          className={`text-body1 font-ptsans text-secondary/90 font-medium pl-2 block ${labelClassName}`}
        >
          {label}
        </label>
      )}
      <textarea
        id={id}
        value={value}
        onChange={(e) => handleInputChange(e.target.value)}
        className={`w-full h-24 text-secondary/90 rounded-xl border-2 placeholder:text-secondary/60 pl-4 py-3 text-body1 font-ptsans resize-none hover:!border-secondary/60 outline-none focus:!border-secondary/65 focus:!outline-2 focus:!outline-secondary/30 ${
          disabled
            ? "bg-background_2/80 border-none cursor-not-allowed"
            : "!border-secondary/35 bg-transparent"
        } ${className}`}
        placeholder={placeholder}
        maxLength={maxlength}
        disabled={disabled}
      />
      {/* <div className="text-body1 font-ptsans text-secondary/70 pl-1">
        {remaining} characters remaining
      </div> */}
      {error && (
        <div className="text-caption text-red-500 font-ptsans pl-2">
          {error}
        </div>
      )}
    </div>
  );
};

export default AddressInputField;
